<template>
    <v-container  v-resize="onResize">
        <statistical-header :title="title"></statistical-header>
        <loader v-if="loading" />
        <template v-if="!loading">
            
            <v-layout row wrap align-left>
                <v-flex xs12 md8 xl8 order-xs2 pb-xs-3>
                    <v-btn-toggle v-model="chartType" class="pb-0 mt-4 mb-0 transparent handbook_toggleButton" :mandatory="true">
                        <v-tooltip top :disabled="this.$vuetify.breakpoint.name !== 'md'">
                            <template v-slot:activator="{ on }">
                                <v-btn v-on="on" class="handbook_button" :value="'longestService'"><span class="long-button-text">Longest service on a committee</span></v-btn>
                            </template>
                            <span>Longest service on a committee</span>
                        </v-tooltip>
                        <v-tooltip top :disabled="this.$vuetify.breakpoint.name !== 'md'">
                            <template v-slot:activator="{ on }">
                                <v-btn v-on="on" class="handbook_button" :value="'mostCommitteesServed'"><span class="long-button-text">Most committees served</span></v-btn>
                            </template>
                            <span>Most committees served</span>
                        </v-tooltip>
                    </v-btn-toggle>
                </v-flex>
                <v-flex xs12 md4 xl4 order-xs1>
                  <v-card-title class="pb-0 mb-0">
                    <v-autocomplete
                      label="Filter by committee types"
                      v-model="COMMITTEE_TYPES_SELECTED"
                      :items="COMMITTEE_TYPE_OPTIONS"
                      item-text="Filter"
                      item-value="Filter"
                      auto-select-first
                      multiple
                      clearable
                      small-chips
                      deletable-chips
                      v-on:change="FILTERBY_TYPE">
                       <template v-slot:selection="{ item, index }">
                            <v-chip @input="deleteSelectionItem(item)" small close v-if="index == 0">{{item}}</v-chip>
                            <v-chip small v-if="index == 1">+ {{COMMITTEE_TYPES_SELECTED.length - 1}} more</v-chip>
                        </template>
                    </v-autocomplete>
                  </v-card-title>
                </v-flex>
            </v-layout>

            <v-radio-group v-show="chartType === 'longestService'" style="position:absolute; margin-top: 40px; z-index: 999; left: 50%;margin-left: -120px;" 
             v-model="longestServiceType" row>
                <v-radio label="Cumulative" value="cumulative"></v-radio>
                <v-radio label="Continuous" value="continuous"></v-radio>
            </v-radio-group>
            
            <chart v-show="chartType === 'longestService'" :chartData="longestService" />
            <chart v-show="chartType === 'mostCommitteesServed'" :chartData="mostCommitteesServed" />

            <br />
            <v-menu v-if="this.isMobile" d-inline offset-y :nudge-left="140" :close-on-content-click="true">
                <v-btn outline small slot="activator">
                    Sort <v-icon>sort</v-icon>
                </v-btn>
                <v-list>
                        <v-subheader
                        >
                        Sort by:
                        </v-subheader>
                    <v-list-tile v-for="(item, index) in HEADERS.filter(h => h.text != '' && h.sortable != false)" :key="item.value" @click="changeSort(item.value)">
                        <v-list-tile-title>
                            {{ item.text }}
                            <v-icon v-if="PAGINATION.sortBy === item.value">{{PAGINATION.descending ? 'arrow_downward':'arrow_upward'}}</v-icon>
                        </v-list-tile-title>
                    </v-list-tile>
                </v-list>
            </v-menu>
            <div class="stats-table"> 
                <v-data-table
                    :headers="HEADERS"
                    :items="DATATABLE_COMMITTEEMEMBERSHIPS"
                    :rows-per-page-items="ROWS_LISTITEMS"
                    :pagination.sync="PAGINATION"
                    v-on:update:pagination="UPDATE_PAGINATION"
                    :hide-headers="isMobile"
                    :class="{ mobileDataTable: isMobile, 'elevation-1': true }">
                    <template v-slot:items="props">
                        <router-link v-if="!isMobile" class="tr" :to="{ name: $store.state.ROUTE_COMMITTEE, params: { CID: props.item.CID}}">
                            <td class="text-xs-left">
                                <v-chip :class="props.item.Type.indexOf('General Purpose') > -1 ? 'generalPurposeStanding' : ''"
                                        :color="props.item.Type.startsWith('Senate')
                                        ? $store.state.COLOUR_SENATE
                                        : props.item.Type.startsWith('House')
                                        ? $store.state.COLOUR_REPRESENTATIVES
                                        : $store.state.COLOUR_JOINT"
                                        small label>
                                    {{ props.item.Type }}
                                </v-chip>
                            </td>
                            <td class="text-xs-left">{{ props.item.CommitteeName }}</td>
                            <td class="text-xs-left">
                                {{ props.item.PersonName }}
                            </td>
                            <td class="text-xs-left">
                                {{ getDateLength(props.item.CompiledServiceLength) }}
                            </td>
                            <td class="text-xs-left">
                                {{ getDateLength(props.item.LongestContinuousService) }}
                            </td>
                        </router-link>
                        <router-link v-if="isMobile" class="tr" :to="{ name: $store.state.ROUTE_COMMITTEE, params: { CID: props.item.CID}}">
                            <td>
                                <ul class="flex-content">
                                    <li class="flex-item" data-label="Parliamentarian">{{ props.item.PersonName }}</li>
                                    <li class="flex-item" data-label="Committee">
                                        <div>{{ props.item.CommitteeName }}</div>
                                        <v-chip :class="props.item.Type.indexOf('General Purpose') > -1 ? 'ml-0 generalPurposeStanding' : 'ml-0'"
                                                :color="props.item.Type.startsWith('Senate')
                                                ? $store.state.COLOUR_SENATE
                                                : props.item.Type.startsWith('House')
                                                ? $store.state.COLOUR_REPRESENTATIVES
                                                : $store.state.COLOUR_JOINT"
                                                small label>
                                            {{ props.item.Type }}
                                        </v-chip>
                                    </li>
                                    <li class="flex-item" data-label="Cumulative service length">{{ getDateLength(props.item.CompiledServiceLength) }}</li>
                                    <li class="flex-item" data-label="Longest continuous service">{{ getDateLength(props.item.LongestContinuousService) }}</li>
                                </ul>
                            </td>
                        </router-link>
                    </template>
                    <template v-slot:no-results>
                    <v-alert :value="true" color="error" icon="warning">
                        Your search found no results.
                    </v-alert>
                    </template>
                </v-data-table>
            </div>
        </template>
    </v-container>
</template>

<script>
import Loader from '@/components/Loader.vue';
import StatisticalHeader from './StatisticalHeader.vue';
import Chart from './Chart.vue';
import CountUp from './CountUp.vue';
import axios from 'axios';
import orderBy from 'lodash.orderby';
import groupBy from 'lodash.groupby';
import map from 'lodash.map';

window.Handbook = window.Handbook || {}
const apiUri = window.Handbook.ApiUri || "https://localhandbookapi.aph.gov.au/";
axios.defaults.baseURL = apiUri;

export default {
    created() {
        this.initialiseStats();
    },
    components: {
        Loader,
        StatisticalHeader,
        Chart
    },
    methods: {
        onResize() {
            if (window.innerWidth < 769){
                this.isMobile = true;
            }
            else {
                this.isMobile = false;
            }
        },
        deleteSelectionItem(item) {
            this.COMMITTEE_TYPES_SELECTED = this.COMMITTEE_TYPES_SELECTED.filter(find => find !== item);
            this.FILTERBY_TYPE(this.COMMITTEE_TYPES_SELECTED);
        },
        getDateLength(days){
            const years = Math.floor(days / 365);
            const months = Math.floor((days - years * 365) / 30);
            const d = Math.round(days - years * 365 - months * 30);

            let res = [];
            if (years > 1) {
                res.push(years + ' years');
            }
            if (years == 1) {
                res.push(years + ' year');
            }
            if (months > 1) {
                res.push(months + ' months');
            }
            if (months == 1) {
                res.push(months + ' month');
            }
            if (d > 1) {
                res.push(d + ' days');
            }
            if (d == 1) {
                res.push(d + ' day');
            }
            let detailDiff = res.join(', ');

            return detailDiff;
        },
        getColor(chamber){
            if (chamber == 'House'){
                return this.$store.state.COLOUR_REPRESENTATIVES;
            }
            else if (chamber == 'Senate'){
                return this.$store.state.COLOUR_SENATE_BRIGHT;
            }
            else if (chamber == 'Joint'){
                return this.$store.state.COLOUR_JOINT;
            }
        },
        UPDATE_PAGINATION: function (options) {
            this.$gtag.event("committees by name pagination items per page", {
                event_category: "filters",
                event_label: `items per page: ${options.rowsPerPage}`,
                value: 1,
            });
            this.$gtag.event("committees by name pagination page", {
                event_category: "filters",
                event_label: `page: ${options.page}`,
                value: 1,
            });
            this.$gtag.event(`committees by name sorting`, {
                event_category: "sorting",
                event_label: `sort by ${options.sortBy} ${
                options.descending ? "DESC" : "ASC"
                }`,
                value: 1,
            });
         
            return this.PAGINATION;
        },
        initialiseStats() {
            this.loading = true;
            const mpOrSenator = this.selectedMpOrSenator.length == 0 || this.selectedMpOrSenator.length == 2 ?
                '' : this.selectedMpOrSenator[0];

            const url = `StatisticalInformation/CommitteeMembershipStatistics?mpOrSenator=${mpOrSenator}`;
            axios.get(`api/${url}`)
                .then(response => {
                    this.committeeMembershipStats = response.data;
                    this.DATATABLE_COMMITTEEMEMBERSHIPS = this.committeeMembershipStats.filter(c => c.CompiledServiceLength > 0);
                    this.loading = false;
                });
        },
        filterMpOrSenator() {
            this.initialiseStats();
        },
        exportCsv: function () {
            this.csvDownloading = true;
            const records = this.items
                .map(i => ({ Date: new Date(i.Date).toLocaleDateString(), ...i.Parties.reduce((ac,a) => ({...ac,[a.Party]: a.WomenCount }),{}) }));
            let headers = this.headers.map(h => h.text);
            const filename = this.title;
            const comment = `Data current as of ${(new Date()).toLocaleDateString()}`;
            this.$store.dispatch('GETCSV', { DATA: records, HEADERS: headers, FILENAME: filename, COMMENT: comment })
                .catch(this.showError)
                .finally(() => this.csvDownloading = false);
        },
        FILTERBY_TYPE: function (types) {
            //No types, add all
            if (types.length == 0) {
                this.COMMITTEE_TYPES_SELECTED.push("All types");
            } else {
                //Went from no items (on load) to multiple. Remove 'All types'
                if (this.COMMITTEE_TYPES_SELECTED_PREVIOUS.length == 0 &&
                    this.COMMITTEE_TYPES_SELECTED.length > 1 &&
                    this.COMMITTEE_TYPES_SELECTED.indexOf("All types") > -1
                    ) {
                    this.COMMITTEE_TYPES_SELECTED.splice(
                        this.COMMITTEE_TYPES_SELECTED.indexOf("All types"),
                        1
                    );
                }
                //Previous list didn't have all types, now we are adding it, allow this to happen
                else if (this.COMMITTEE_TYPES_SELECTED.indexOf("All types") > -1 &&
                    (this.COMMITTEE_TYPES_SELECTED_PREVIOUS.indexOf("All types") == -1 ||
                        this.COMMITTEE_TYPES_SELECTED_PREVIOUS.length == 0)
                ) {
                    this.COMMITTEE_TYPES_SELECTED = ["All types"];
                }
                //In all other cases, remove 'all types' if user has selected other options
                else if (this.COMMITTEE_TYPES_SELECTED.indexOf("All types") > -1) {
                    this.COMMITTEE_TYPES_SELECTED.splice(
                        this.COMMITTEE_TYPES_SELECTED.indexOf("All types"),
                        1
                    );
                }
            }

            this.COMMITTEE_TYPES_SELECTED_PREVIOUS = types;
            return this.FILTER_COMMITTEES();
        },
        FILTERBY_PARLIAMENT: function (parliaments) {
            this.$gtag.event("committees by parliament parliament filter", {
                event_category: "filters",
                event_label: `parliaments selected: ${
                parliaments.length > 0 ? parliaments.join(",") : "none"
                }`,
                value: 1,
            });
            return this.FILTER_COMMITTEES();
        },
        FILTER_PARLIAMENT_OPTIONS: function (item, queryText) {
            const pId = item.PID;
            const name = item.Name.toLowerCase();
            const searchText = queryText.toLowerCase();
            return (
                name.indexOf(searchText) > -1 || pId.toString().indexOf(searchText) > -1
            );
        },
        CLICK_CURRENTPARLIAMENT: function () {
            this.$nextTick(() => {
                let parliaments = this.$store.getters.GET_PARLIAMENTS_ORDERED;
                let currentParliament = parliaments[0].PID;
                if (this.SELECTED_PARLIAMENTS.includes(currentParliament)) {
                    let index = this.SELECTED_PARLIAMENTS.indexOf(currentParliament);
                    if (index > -1) {
                        this.SELECTED_PARLIAMENTS.splice(index, 1);
                    }
                } else {
                    this.SELECTED_PARLIAMENTS.push(currentParliament);
                }
                this.FILTERBY_PARLIAMENT(this.SELECTED_PARLIAMENTS);
            });
        },
        FILTER_COMMITTEES: function () {
            let OBJ_records = this.committeeMembershipStats;
            let OBJ_types = [];
            let index = 0;

    
            if (this.COMMITTEE_TYPES_SELECTED.length > 0) {
                if (OBJ_records.length === 0) {
                    OBJ_records = this.committeeMembershipStats;
                }

                var showAll = false;

                for (index = 0; index < this.COMMITTEE_TYPES_SELECTED.length; ++index) {
                    var txtVal = this.COMMITTEE_TYPES_SELECTED[index].replace(" of Representatives", "");
                    if (txtVal == "All types") {
                        showAll = true;
                    }
                    OBJ_types = OBJ_types.concat(
                        OBJ_records.filter((Obj) => Obj.Type === txtVal)
                    );
                }

                if (showAll) {
                    OBJ_types = OBJ_records;
                }
            }

            const recordsResult = OBJ_types;

            let query = this.$router.query || {};

            if (this.COMMITTEE_TYPES_SELECTED.length > 0) {
                query.committeeTypes = this.COMMITTEE_TYPES_SELECTED.join(",");
            }

            if (this.SELECTED_PARLIAMENTS.length > 0) {
                query.parliaments = this.SELECTED_PARLIAMENTS.join(",");
            }

            if (this.COMMITTEE_TYPES_SELECTED.length > 0) {
                this.DATATABLE_COMMITTEEMEMBERSHIPS = this._.sortBy(
                recordsResult,
                "CompiledServiceLength"
                );
            } else {
                this.DATATABLE_COMMITTEEMEMBERSHIPS = [];
            }

            if (Object.keys(query).length > 0) {
                history.replaceState(
                {},
                null,
                this.$route.path +
                    "?" +
                    Object.keys(query)
                    .map((key) => {
                        return key + "=" + query[key];
                    })
                    .join("&")
                );
            } else {
                history.replaceState({}, null, this.$route.path);
            }
            return true;
        },
        changeSort(column) {
            if (this.PAGINATION.sortBy === column) {
                this.PAGINATION.descending = !this.PAGINATION.descending
            } 
            else {
                this.PAGINATION.sortBy = column
                this.PAGINATION.descending = false
            }
        },
    }, 
    computed: {
        currentParliamentIcon: function () {
            let parlArray = this.$store.getters.GET_PARLIAMENTS_ORDERED;
            let currentParliament = parlArray[0].PID;
            if (this.SELECTED_PARLIAMENTS.indexOf(currentParliament) > -1) {
                return '$vuetify.icons.checkboxOn';
            } else {
                return '$vuetify.icons.checkboxOff';
            }
        },
        currentParliamentValue: function () {
            let parlArray = this.$store.getters.GET_PARLIAMENTS;
            if (
                this.SELECTED_PARLIAMENTS.includes(parlArray[parlArray.length - 1].PID)
            ) {
                return parlArray[parlArray.length - 1].PID;
            } else {
                return false;
            }
        },
        csvDownloadIcon() {
            return this.csvDownloading ? 'cached' : 'text_snippet';
        },
        csvDownloadClass() {
            let csvClass = 'mr-1';
            if (this.csvDownloading){
                csvClass = csvClass + ' loading'
            }
            return csvClass;
        },
        longestService() {
            var that = this;
            var top10CommitteesCumulative = orderBy(this.DATATABLE_COMMITTEEMEMBERSHIPS, ['CompiledServiceLength'], ['desc']).slice(0, 10);
            var top10CommitteesContinuous = orderBy(this.DATATABLE_COMMITTEEMEMBERSHIPS, ['LongestContinuousService'], ['desc']).slice(0, 10);

            return {
                chart: {
                    type: 'bar'
                },
                title: {
                    text: 'Longest service on a single committee',
                    margin: 40
                },
                xAxis: {
                    categories: this.longestServiceType == 'cumulative' ? top10CommitteesCumulative.map(p => p.PersonName + ' (' + p.Type + ' - ' + p.CommitteeName + ')') 
                        : top10CommitteesContinuous.map(p => p.PersonName + ' (' + p.Type + ' - ' + p.CommitteeName + ')') ,
                },
                yAxis: {
                    title: {
                        text: 'Years'
                    }
                },
                plotOptions: {
                    bar: {
                        dataLabels: {
                            enabled: true,
                            format: '{y:.2f} years' 
                        }
                    }
                },
                tooltip: {
                    pointFormat: '{series.name}: <b>{point.y:.2f} years</b><br/>',
                    followPointer: true
                },
                exporting: {
                    filename: 'Longest service on a single committee'
                },
                series: [{
                    name: '',
                    data: this.longestServiceType == 'cumulative' 
                        ? top10CommitteesCumulative.map(p => ({
                                color: p.Type.startsWith('House') ? this.$store.state.COLOUR_REPRESENTATIVES 
                                : (p.Type.startsWith('Senate') ? this.$store.state.COLOUR_SENATE_BRIGHT : this.$store.state.COLOUR_JOINT),
                                y: p.CompiledServiceLength / 365,
                                events: {
                                    click: function () {
                                        that.$router.push({  name: that.$store.state.ROUTE_COMMITTEE, params: { CID: p.CID}});
                                    }
                                },
                            })) 
                        : top10CommitteesContinuous.map(p => ({
                            color: p.Type.startsWith('House') ? this.$store.state.COLOUR_REPRESENTATIVES 
                            : (p.Type.startsWith('Senate') ? this.$store.state.COLOUR_SENATE_BRIGHT : this.$store.state.COLOUR_JOINT),
                            y: p.LongestContinuousService / 365,
                            events: {
                                click: function () {
                                    that.$router.push({  name: that.$store.state.ROUTE_COMMITTEE, params: { CID: p.CID}});
                                }
                            },
                        }))
                }],
                legend: {
                    enabled: false
                }
            }
        },
        mostCommitteesServed() {
             var that = this;
            const grouped = groupBy(this.DATATABLE_COMMITTEEMEMBERSHIPS, d => d.PHID);
                const series = orderBy(map(
                    grouped,
                    (value, key) => ({
                        name: key,
                        label: value[0].PersonName + ' (' + value[0].MPorSenator + ')',
                        data: value.length,
                        PHID: value[0].PHID,
                        color: value[0].MPorSenator == 'Member' ? this.$store.state.COLOUR_REPRESENTATIVES 
                            : this.$store.state.COLOUR_SENATE_BRIGHT,
                    })), [s => s.data], ['desc']).slice(0, 10);


            return {
                chart: {
                    type: 'bar'
                },
                title: {
                    text: 'Parliamentarians who served on the most committees'
                },
                xAxis: {
                    categories: series.map(p => p.label),
                },
                yAxis: {
                    title: {
                        text: 'Committees served'
                    }
                },
                plotOptions: {
                    bar: {
                        dataLabels: {
                            enabled: true,
                            format: '{y} committees' 
                        }
                    }
                },
                tooltip: {
                    pointFormat: '{series.name}: <b>{point.y} committees</b><br/>',
                    followPointer: true
                },
                exporting: {
                    filename: 'Parliamentarians who served on the most committees'
                },
                series: [{
                    name: '',
                    data: series.map(p => ({
                        y: p.data,
                        color: p.color,
                        events: {
                            click: function () {
                                that.$router.push({ name: that.$store.state.ROUTE_PARLIAMENTARIAN, params: { PHID: p.PHID}});
                            }
                        },
                    }))
                }],
                legend: {
                    enabled: false
                }
            }
        },
    },
    watch: {
        selectedMpOrSenator: function () {
            this.initialiseStats();
            this.FILTER_COMMITTEES();
        }
    },
    mounted() {
        this.onResize();

        if (this.$route.query.committeeTypes) {
            this.COMMITTEE_TYPES_SELECTED = this.$route.query.committeeTypes
                .split(",")
                .map((p) => p.replace("%20", ""));
        } else {
            this.COMMITTEE_TYPES_SELECTED = ["All types"];
        }

        if (this.$route.query.parliaments) {
            this.SELECTED_PARLIAMENTS = this.$route.query.parliaments
                .split(",")
                .map((p) => parseInt(p));
        }

        this.FILTER_COMMITTEES();
    },
    data() {
        return {
        isMobile: false,
        title: 'Committee membership statistics',
        headers: [],
        items: [],
        committeeMembershipStats: [],
        chartType: 'longestService',
        PARLIAMENTS: this.$store.getters.GET_PARLIAMENTS,
        SELECTED_PARLIAMENTS: [],
        committees: [],
        currentParliament: 0,
        DATATABLE_COMMITTEEMEMBERSHIPS: [],
        COMMITTEE_TYPE_OPTIONS: [
            "All types",
            "House of Representatives Select",
            "House of Representatives Standing",
            "Senate Estimates",
            "Senate Legislative and General Purpose Standing",
            "Senate Select",
            "Senate Standing",
            "Joint Select",
            "Joint Standing",
            "Joint Statutory",
        ],
        COMMITTEE_TYPES_SELECTED: [],
        COMMITTEE_TYPES_SELECTED_PREVIOUS: [],
        totalStats: [],
        longestServiceType: 'cumulative',
        committeeData: [],
        ROWS_LISTITEMS: [
        10,
        20,
        50,
        100,
        {
          text: "$vuetify.dataIterator.rowsPerPageAll",
          value: -1,
        },
      ],
        percentage: 0,
        committeeCount: 0,
        currentCommitteeCount: 0,
        totalStatsOptions: {
            suffix: '%'
        },
        PAGINATION: {
            rowsPerPage: 50,
            descending: true,
            sortBy: "CompiledServiceLength",
        },
        HEADERS: [
        {
          text: "Committee type",
          value: "CommitteeType",
          align: "left",
          sortable: true,
          width: "100px",
        },
        {
          text: "Committee name",
          value: "CommitteeName",
          align: "left",
          sortable: true,
          model: this.committeeName,
        },
        {
          text: "Parliamentarian",
          value: "PersonName",
          align: "left",
          sortable: true,
        },
        {
          text: "Cumulative service length",
          value: "CompiledServiceLength",
          align: "left",
          sortable: true,
          width: "250px",
        },{
          text: "Longest continuous service",
          value: "LongestContinuousService",
          align: "left",
          sortable: true,
          width: "250px",
        },
        
      ],
        parties: [],
        partiesExcludingTotal: [],
        search: '',
        loading: true,
        csvDownloading: false,
        selectedMpOrSenator: ['senator', 'mp'],
        rowsPerPageItems: [ {
            "text": "$vuetify.dataIterator.rowsPerPageAll",
            "value": -1
            }]
        }
    }
}
</script>
<style scoped>
    .chamberButton {
        color: #f5f5f5;
    }
    .handbook_toggleButton {
        flex-wrap: wrap;
    }
</style>
<style lang="stylus" scoped>
    .generalPurposeStanding {
        height: 35px !important;
        line-height: 14px;
    }

    .generalPurposeStanding >>> .v-chip__content {
        width: 180px !important;
        word-break: break-word;
        overflow-wrap: break-word;
        white-space: normal;
    }
    
    .v-input--radio-group >>> .v-label {
        color: rgb(14, 21, 49);
    }

    @media screen and (max-width: 1420px) {
        .stats-table >>> table.v-table thead td:not(:nth-child(1)), 
        .stats-table >>> table.v-table tbody td:not(:nth-child(1)), 
        .stats-table >>> table.v-table thead th:not(:nth-child(1)), 
        .stats-table >>> table.v-table tbody th:not(:nth-child(1)), 
        .stats-table >>> table.v-table thead td:first-child, 
        .stats-table >>> table.v-table tbody td:first-child, 
        .stats-table >>> table.v-table thead th:first-child, 
        .stats-table >>> table.v-table tbody th:first-child,
        .stats-table >>> table.v-table thead th:first-child {
            padding: 0 14px !important;
        }

        .stats-table >>> th {
            white-space: break-spaces;
        }
    }

    
</style>
